import React from "react";
import classNames from "classnames";
import useIsNoIframe from "../../hooks/useIsNoIframe";

function CardWrapper({ isWrapped, children }) {
  const { isNoIframe } = useIsNoIframe();

  return (
    <section
      className={classNames("card-wrapper", {
        ["card-wrapped"]: isWrapped,
        ["card-noIframe"]: isNoIframe,
      })}
    >
      {children}
    </section>
  );
}

export default CardWrapper;
